import enUSTranslation from './locales/en/translation.json'
import deDETranslation from './locales/de/translation.json'

export const Languages = {
  en: 'en',
  de: 'de',
}

export const resources = {
  [Languages.en]: {
    translation: enUSTranslation,
  },
  [Languages.de]: {
    translation: deDETranslation,
  },
}

export function fallbackLng(code: string) {
  const fallbacks = ['en']
  const [lang] = code.split(/[_-]/)
  const normalizedLang = lang.toLowerCase()

  if (!fallbacks.includes(normalizedLang)) {
    fallbacks.unshift(normalizedLang)
  }

  return fallbacks
}
